<template>
  <div class="menu-submenu">
    <span class="menu-arrow"></span>
    <ul class="menu-subnav">
      <li class="menu-item kt-menu-item-parent" aria-haspopup="true">
        <span class="menu-link">
          <span class="menu-link-text">
            {{
            parentMenu ? parentMenu.title : ""
            }}
          </span>
        </span>
      </li>
      <template v-for="(menu, i) in submenu">
        <li
          class="menu-item"
          aria-haspopup="true"
          :key="i"
          :class="{
            'menu-item-submenu': menu.submenu,
            'menu-item-open': activeMenu(menu)
          }"
          :data-ktmenu-submenu-toggle="submenuToggle(menu)"
        >
          <KTMenuItemText v-bind:menu="menu" v-bind:parentMenu="parentMenu"></KTMenuItemText>
          <KTMenuSubmenu v-if="menu.submenu" v-bind:submenu="menu.submenu"></KTMenuSubmenu>
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
import KTMenuItemText from "@/view/layout/aside/MenuItemText.vue";
import KTMenuSubmenu from "@/view/layout/aside/MenuSubmenu.vue";

export default {
  name: "KTMenuSubmenu",
  components: {
    KTMenuItemText,
    KTMenuSubmenu
  },
  props: {
    submenu: Array,
    parentMenu: Object
  },
  methods: {
    /**
     * Get submenu toggle type
     * @param menu
     * @returns {string|*}
     */
    submenuToggle(menu) {
      if (menu.hasOwnProperty("toggle")) {
        return menu.toggle;
      }
      return "hover";
    },
    activeMenu(input) {
      const paths = Array.isArray(input) ? input : [input];
      return paths.some(conf => {
        if (conf.submenu) {
          return this.activeMenu(conf.submenu);
        }
        if (conf.page) {
          // current path starts with this path string
          return this.$route.path === `/${conf.page}`;
        }
      });
    }
  }
};
</script>
